<template>
  <div class="argicProduct">
    <el-dialog
      title=""
      :visible.sync="showArgicProduct"
      :close-on-click-modal="false"
      width="1000px"
      :before-close="handleClose"
    >
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="已出库待使用农资" name="1">
          <out-argic-product
            :sysMissionCategoryId="sysMissionCategoryId"
            :selected-list="selectedList"
            @select-farm-res="selectResources"
          ></out-argic-product>
        </el-tab-pane>
        <!-- 航育不需要系统农资 -->
        <!-- <el-tab-pane label="系统农资" name="2" v-if="supervisionFlag === 0">
          <sys-arigc-product
            :sysMissionCategoryId="sysMissionCategoryId"
            :selected-list="selectedList"
            @select-farm-res="selectResources"
          ></sys-arigc-product>
        </el-tab-pane> -->
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import OutArgicProduct from "./OutArgicProduct";
// import SysArigcProduct from "./SysArigcProduct";

export default {
  components: {
    OutArgicProduct,
    // SysArigcProduct,
  },
  data() {
    return {
      activeName: "1",
      supervisionFlag: 0,
    };
  },
  props: {
    showArgicProduct: {
      type: Boolean,
      default: false,
    },
    selectedList: {
      type: Array,
      default: () => [],
    },
    sysMissionCategoryId: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    // 获取监管信息
    this.supervisionFlag = JSON.parse(
      localStorage.getItem("COMPANYINFO")
    ).supervisionFlag;
  },
  methods: {
    selectResources(item) {
      var hasId = this.selectedList.some(function (v) {
        return v.agriResId === item.agriResId;
      });
      if (hasId) {
        this.$message("已经选择过此农资");
        return false;
      }
      item.dose = "";
      this.$emit("updateSelectedList", item);
      this.$emit("closeDialog", false);
    },
    handleClose() {
      this.$emit("closeDialog", false);
    },
    handleClick() {},
  },
};
</script>

<style scoped lang="scss">
.argicProduct {
  ::v-deep .el-tabs__item {
    font-size: 18px;
    font-weight: 700;
  }
  ::v-deep .el-dialog .el-dialog__header {
    padding: 0 !important;
  }
}
</style>
